import React from 'react'
import { Box, BoxProps, Typography, useTheme } from '@mui/material'

interface MessageProps {
  variant: 'success' | 'error' | 'info'
}

enum BackgroundColorMap {
  success = 'green',
  error = 'red',
  info = 'yellow1',
}

enum ColorMap {
  success = 'white',
  error = 'white',
  info = 'black',
}

const Message: React.FC<MessageProps & BoxProps> = ({ variant, sx, children, ...rest }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        textAlign: 'center',
        backgroundColor: theme.custom.colors.common[BackgroundColorMap[variant]],
        color: theme.custom.colors.common[ColorMap[variant]],
        ...sx,
      }}
      {...rest}
    >
      <Typography variant="body1">{children}</Typography>
    </Box>
  )
}

export const ErrorMessage: React.FC<BoxProps> = ({ children, ...rest }) => (
  <Message variant="error" {...rest}>
    {children}
  </Message>
)

export const SuccessMessage: React.FC<BoxProps> = ({ children, ...rest }) => (
  <Message variant="success" {...rest}>
    {children}
  </Message>
)

export const InfoMessage: React.FC<BoxProps> = ({ children, ...rest }) => (
  <Message variant="info" {...rest}>
    {children}
  </Message>
)
